var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "row filter-bar pb-2 pb-md-0" },
        [_vm._t("filterSlot")],
        2
      ),
      _vm._v(" "),
      !_vm.stripped
        ? _c("div", { staticClass: "row" }, [
            _vm.selectable || _vm.editable
              ? _c(
                  "div",
                  { staticClass: "col lists-header" },
                  [
                    _c(
                      "b-button-group",
                      { staticClass: "float-right ml-3" },
                      [
                        _c("q-icon", {
                          attrs: {
                            active: _vm.displayStyle === "list",
                            width: "20px",
                            height: "20px",
                            pack: "leftMenu",
                            altPack: "leftMenu",
                            name: "listGrey",
                            altName: "listGreen"
                          },
                          on: {
                            click: function($event) {
                              _vm.displayStyle = "list"
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("q-icon", {
                          staticStyle: { "margin-left": "13px" },
                          attrs: {
                            active: _vm.displayStyle === "grid",
                            width: "20px",
                            height: "20px",
                            pack: "leftMenu",
                            altPack: "leftMenu",
                            name: "gridGrey",
                            altName: "gridGreen"
                          },
                          on: {
                            click: function($event) {
                              _vm.displayStyle = "grid"
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.selectable && !_vm.limitSelection
                      ? _c(
                          "b-button-group",
                          { staticClass: "float-right mr-3 button-space" },
                          [
                            _c("input-button", {
                              attrs: {
                                btnStyle: "link-style",
                                pointable: "",
                                variant: "plainText",
                                inputPlaceholder: _vm.$t("Button.selectAll")
                              },
                              on: { click: _vm.selectAll }
                            }),
                            _vm._v(" "),
                            _c("input-button", {
                              attrs: {
                                btnStyle: "link-style",
                                pointable: "",
                                variant: "plainText",
                                inputPlaceholder: _vm.$t("Button.unselectAll")
                              },
                              on: { click: _vm.deselectAll }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ],
                  1
                )
              : _vm._e()
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasPages
        ? _c("pagination-navigation", {
            attrs: { paginationInfo: _vm.paginationInfo },
            on: { prevpage: _vm.prevPage, nextpage: _vm.nextPage }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "spacer-list d-none d-md-block" }),
      _vm._v(" "),
      _c("div", { staticClass: "spacer-list-smaller d-block d-md-none" }),
      _vm._v(" "),
      _c(
        "div",
        {
          class: {
            "post-list-items": true,
            row: true,
            scrollable: _vm.scrollable
          }
        },
        _vm._l(_vm.displayList, function(item) {
          return _vm.isExcluded(item.id)
            ? _c("div", { key: item.id, class: _vm.getItemClass(item.id) }, [
                _vm.displayed === item.__typename || _vm.displayed === "all"
                  ? _c("div", [
                      item.deleted
                        ? _c("div", { staticClass: "msg-deleted" }, [
                            _c("p", [
                              _vm._v(
                                "\n            This item has been deleted from the server.\n          "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        { class: _vm.postStatus(item) },
                        [
                          _c("item-post", {
                            ref: _vm.getItemsUid(item),
                            refInFor: true,
                            attrs: {
                              displayStyle: _vm.displayStyle,
                              type: _vm.getType(item),
                              image: _vm.getImage(item),
                              title: _vm.getTitle(item),
                              price: _vm.getItemsPrice(item),
                              discount: _vm.getItemsDiscount(item),
                              datePost: _vm.getItemsDateToPost(item),
                              dateDiscount: _vm.getDiscountValidity(item),
                              url: _vm.getItemsUrl(item),
                              uid: _vm.getItemsUid(item),
                              postSelected: _vm.isSelected(item.id),
                              content: _vm.getItemsContent(item),
                              imported: item.type === "importedProduct",
                              selectable: _vm.selectable,
                              editable: _vm.editable,
                              deleted: item.deleted
                            },
                            on: {
                              selected: _vm.selectPost,
                              editPost: _vm.updatePost,
                              deletePost: _vm.deletePost
                            }
                          })
                        ],
                        1
                      )
                    ])
                  : _vm._e()
              ])
            : _vm._e()
        }),
        0
      ),
      _vm._v(" "),
      _vm.hasPages
        ? _c("pagination-navigation", {
            staticClass: "pagination-bottom",
            attrs: { paginationInfo: _vm.paginationInfo },
            on: { prevpage: _vm.prevPage, nextpage: _vm.nextPage }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10e0fadd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10e0fadd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/standard/display/PostList.vue
// module id = null
// module chunks = 